import { Component, OnInit, inject } from '@angular/core';
import {Router} from '@angular/router';
import {ZoneService} from '../../../zone/zone.service';
import {Observable} from 'rxjs';
import {Zone} from '../../../zone/zone';
import {ClientService} from '../../../client/client.service';
import {Client} from '../../../client/client';
import {Diensten} from "../../../dienst/diensten";
import {DienstService} from "../../../dienst/dienst.service";

@Component({
    templateUrl: './add-client.page.html',
    styleUrls: ['./add-client.page.scss'],
    standalone: false
})
export class AddClientPage implements OnInit {
  private clientService = inject(ClientService);
  private dienstService = inject(DienstService);
  private zoneService = inject(ZoneService);
  private router = inject(Router);

  zones$: Observable<Array<Zone>>;
  diensten$: Observable<Diensten>;

  private requestBusy = false;

  ngOnInit(): void {
    this.zones$ = this.zoneService.getZones$();
    this.diensten$ = this.dienstService.getDiensten$();
  }

  onCancelClicked(): void {
    this.router.navigateByUrl('/clienten');
  }

  onAddClicked(client: Client): void {
    if (!this.requestBusy) {
      this.requestBusy = true;
      this.clientService.postClient$(client)
        .subscribe(
          newClient => this.router.navigateByUrl(`/clienten/${newClient.getId()}/diensten/beheer`),
          () => this.requestBusy = false,
          () => this.requestBusy = false,
        );
    }
  }
}
